import React, { useEffect } from "react";
import LabelWithInput from "@components/input/LabelWithInput";
import { useFormContext } from "react-hook-form";
import BasicFormInput from "@components/input/BasicFormInput";
import styled from "@emotion/styled";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "4rem",
});

const Description = styled.div(({ theme }) => ({
  color: theme.color.gray,
  lineHeight: "12px",
  fontSize: "1.2rem",
}));

const ErrorMessage = styled.div(({ theme }) => ({
  color: theme.color.orange,
  fontSize: "1.2rem",
}));

const ProductNameInput = ({ nameRef }: { nameRef?: any }) => {
  const {
    watch,
    trigger,
    formState: { errors },
  } = useFormContext();

  const name_ko = watch("name_ko");
  const name_en = watch("name_en");

  useEffect(() => {
    if (name_ko) {
      trigger("name_ko");
    }
  }, [name_ko, trigger]);

  useEffect(() => {
    if (name_en) {
      trigger("name_en");
    }
  }, [name_en, trigger]);

  return (
    <Container ref={nameRef}>
      {/* <FadeInContainer isShow={isShow}> */}
      <LabelWithInput label="상품명 (국문)" required>
        <BasicFormInput
          name="name_ko"
          placeholder="상품명을 입력해주세요. (최대 100자)"
          max={100}
        />
        {errors?.name_ko && (
          <ErrorMessage>{errors?.name_ko?.message?.toString()}</ErrorMessage>
        )}
      </LabelWithInput>
      {/* </FadeInContainer> */}

      {/* <FadeInContainer isShow={isShow}> */}
      <LabelWithInput label="상품명 (영문)" required>
        <Description>
          번역된 버전에서는 영문으로 표시되며, 영문명이 없는 경우 등록할 수
          없습니다.
        </Description>
        <BasicFormInput
          name="name_en"
          placeholder="상품명을 입력해주세요. (최대 100자)"
          max={100}
        />
        {errors?.name_en && (
          <ErrorMessage>{errors?.name_en?.message?.toString()}</ErrorMessage>
        )}
      </LabelWithInput>
      {/* </FadeInContainer> */}
    </Container>
  );
};

export default ProductNameInput;
